const importAll = (r) => {
    let images = {};
    r.keys().forEach((item) => {
        const key = item.replace('./', '').replace('.webp', '');
        images[key] = r(item);
    });
    return images;
};

// This assumes Webpack (standard Create React App)
const categoryIcons = importAll(require.context('../../assets/service-categories', false, /\.(webp)$/));

export default categoryIcons;
